var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 0.666656C21.3598 0.666656 27.3332 6.63999 27.3332 14C27.3332 21.36 21.3598 27.3333 13.9998 27.3333C6.63984 27.3333 0.666504 21.36 0.666504 14C0.666504 6.63999 6.63984 0.666656 13.9998 0.666656ZM6.0305 18.5547C7.98784 21.4747 10.9265 23.3333 14.2132 23.3333C17.4985 23.3333 20.4385 21.476 22.3945 18.5547C20.1755 16.4808 17.2504 15.3291 14.2132 15.3333C11.1755 15.3287 8.24985 16.4805 6.0305 18.5547ZM13.9998 12.6667C15.0607 12.6667 16.0781 12.2452 16.8283 11.4951C17.5784 10.7449 17.9998 9.72752 17.9998 8.66666C17.9998 7.60579 17.5784 6.58838 16.8283 5.83823C16.0781 5.08808 15.0607 4.66666 13.9998 4.66666C12.939 4.66666 11.9216 5.08808 11.1714 5.83823C10.4213 6.58838 9.99984 7.60579 9.99984 8.66666C9.99984 9.72752 10.4213 10.7449 11.1714 11.4951C11.9216 12.2452 12.939 12.6667 13.9998 12.6667Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.343f1e0b516c6a30ac365c08d63c2370.svg";
export { ForwardRef as ReactComponent };